import axios from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});

export default {
  install(Vue, store) {
    Vue.prototype.$axios = axiosInstance;
    if (store) {
      store.$axios = axiosInstance;
    }
  },
};
